export default {
  "pl": {
    "reminder": {
      "actions": {
        "edit": "Edytuj",
        "hideReminders": "Ukryj przypomnienia",
        "cancel": "Zresetuj",
        "save": "Zapisz",
        "showReminders": "Pokaż przypomnienia"
      },
      "contactType": {
        "customer": "Klient",
        "partner": "Partner"
      },
      "labels": {
        "after": "po",
        "before": "przed",
        "click": "Kliknij, aby ustawić przypomnienie",
        "date": "w dniu: {date}",
        "dateAfterDueDate": "Po terminie ukończenia",
        "dateAlreadyPassed": "data już upłynęła",
        "decisionApprovedNotSent": "Decyzja została już podjęta. Przypomnienia, które znajdowały się w kolejce, zostały anulowane.",
        "dueDate": "ostateczny termin",
        "here": "tutaj",
        "noReminderSet": "Nie ustawiono przypomnienia",
        "reminder": "Przypomnienie",
        "reminders": "Przypomnienia",
        "remindersCustomer": "Przypomnienia dla klienta",
        "remindersPartners": "Przypomnienia dla partnera(-ów)",
        "sendOnDeadline": "Przypomnienie zostanie wysłane, gdy nadejdzie termin ukończenia",
        "sendReminder": "Wyślij przypomnienie",
        "sent_at": "Przypomnienie wysłano dnia {date}",
        "warningReminders": "Wszystkie 4 przypomnienia zostaną nadpisane w przypadku każdej decyzji. Dotyczy to również przypomnień nieuzupełnionych."
      },
      "toasts": {
        "update": "Przypomnienie zostało zaktualizowane"
      }
    }
  }
}
